import { InjectedIntl } from 'react-intl';
import { SocialProviderName } from '../types/socialAccounts.types';

/**
 * Maps service names from backend to translation keys
 */
const SERVICE_NAME_TO_KEY_MAP: Record<string, string> = {
    'Rakuten Travel Global': 'service.name.rakuten.travel.global',
    'Rakuten Travel Taiwan': 'service.name.rakuten.travel.taiwan',
    'Rakuten Travel Korea': 'service.name.rakuten.travel.korea',
};

/**
 * Maps provider names to translation keys
 */
const PROVIDER_NAME_TO_KEY_MAP: Record<SocialProviderName, string> = {
    Google: 'provider.name.google',
    Facebook: 'provider.name.facebook',
    Apple: 'provider.name.apple',
};

/**
 * Translates a service name to the localized version
 * Falls back to the original name if no translation is found
 */
export function getTranslatedServiceName(serviceName: string, intl: InjectedIntl): string {
    const translationKey = SERVICE_NAME_TO_KEY_MAP[serviceName];
    if (translationKey) {
        return intl.formatMessage({ id: translationKey, defaultMessage: serviceName });
    }
    return serviceName; // Fallback to original name
}

/**
 * Translates a provider name to the localized version
 * Falls back to the original name if no translation is found
 */
export function getTranslatedProviderName(
    providerName: SocialProviderName,
    intl: InjectedIntl,
): string {
    const translationKey = PROVIDER_NAME_TO_KEY_MAP[providerName];
    if (translationKey) {
        return intl.formatMessage({ id: translationKey, defaultMessage: providerName });
    }
    return providerName; // Fallback to original name
}
